import { HomeClient } from "./homes";
import { ProjectClient } from "./projects";

export class MemberManagementClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/member-management`;

    this.homes = new HomeClient(this.httpClient, this.baseURL);
    this.projects = new ProjectClient(this.httpClient, this.baseURL);
  }
}
